/**
 * Shared datetime formatting for terminal sequence/queue cards (moment + app TZ).
 */

export function normalizeDateInput (raw) {
  if (raw == null) {
    return null
  }
  if (typeof raw === 'object' && raw.date) {
    return raw.date
  }
  return raw
}

/**
 * @param {import('moment')} moment
 * @param {*} raw
 * @param {string} appTimeZone
 * @param {string} locale
 * @returns {string}
 */
export function formatDateTimeShort (moment, raw, appTimeZone, locale) {
  const v = normalizeDateInput(raw)
  if (!v) {
    return '—'
  }
  const m = moment(v).tz(appTimeZone)
  if (!m.isValid()) {
    return '—'
  }
  const loc = locale || 'en'
  return m.locale(loc).format('HH:mm, D MMM')
}

/**
 * @param {import('moment')} moment
 * @param {*} raw
 * @param {string} appTimeZone
 * @param {string} locale
 * @returns {string}
 */
export function formatTimeHHmm (moment, raw, appTimeZone, locale) {
  const v = normalizeDateInput(raw)
  if (!v) {
    return '—'
  }
  const m = moment(v).tz(appTimeZone)
  if (!m.isValid()) {
    return '—'
  }
  const loc = locale || 'en'
  return m.locale(loc).format('HH:mm')
}

/**
 * @param {*} raw
 * @param {(key: string, values?: object) => string} t — i18n translate
 * @returns {string}
 */
export function timeAgoHoursFromRaw (raw, t) {
  const v = normalizeDateInput(raw)
  if (!v) {
    return '—'
  }
  const d = new Date(v)
  if (Number.isNaN(d.getTime())) {
    return '—'
  }
  const diff = Math.floor((Date.now() - d.getTime()) / 3600000)
  if (diff < 1) {
    return t('terminal.sequence.timeAgoLt1h')
  }
  if (diff < 24) {
    return t('terminal.sequence.timeAgoHoursAgo', { n: diff })
  }
  const days = Math.floor(diff / 24)
  return t('terminal.sequence.timeAgoDaysAgo', { n: days })
}
